export const convertTelegramNodes = async () => {
  const { initTelegramWidgets } = await import('./telegram-widget');
  initTelegramWidgets({ window, document });
};
